import styled from "@emotion/styled";
import { Button, IconArrow } from "atoms";
import { useLocation, useNavigate } from "react-router-dom";
import { paths } from "utils/paths";

type PortfolioBackButtonProps = {
  artistId: string;
  isEditing?: boolean;
};

function GalleryBackButton({ artistId, isEditing }: PortfolioBackButtonProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const goBack = () => {
    if (location.key === "default") {
      // if this is the first page you visited in this window/tab, go to portfolio
      return navigate(
        isEditing
          ? paths.artistPortfolioEdit(artistId)
          : paths.artistPortfolio(artistId)
      );
    }
    // if you came from anywhere else, go back
    return navigate(-1);
  };
  return (
    <BackButton size="xs" variant="blank" aria-label="Back" onClick={goBack}>
      <IconArrow dir="l" aria-hidden /> Back
    </BackButton>
  );
}

const BackButton = styled(Button)({
  borderColor: "transparent",
  justifyContent: "flex-start",
  gap: 6,
  "&&:hover, &&:focus-visible": { borderColor: "transparent" },
});

export { GalleryBackButton };
